import { render } from "./FolderBreadcrumbs.vue?vue&type=template&id=77c54b7e"
import script from "./FolderBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./FolderBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__